import React, { useEffect } from "react";
import { ConnectedRouter } from "react-router-redux";
import { Provider } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";

import history from "./redux/history";
import store from "./redux/store";
import { initLogging, removeLogging } from "./utils/sentry";

import CapitalMarketsDashboard from "./capital_markets_dashboard/CapitalMarketsDashboard";
import DocumentViewer from "./underwriter_dashboard/DocumentViewer";
import FourOhFour from "./404";
import LoanOfficerDashboard from "./loan_officer_dashboard/LoanOfficerDashboard";
import Login from "./Login";
import ReportingDashboard from "./reporting_dashboard/ReportingDashboard";
import SettlementAgentDashboard from "./settlement_agent_dashboard/SettlementAgentDashboard";
import UnderwriterDashboard from "./underwriter_dashboard/UnderwriterDashboard";
import ToolsDashboard from "./tools_dashboard/ToolsDashboard";
import ErrorBoundary from "./shared/ErrorBoundary";

const { IntlProvider } = require("react-intl");

const App = () => {
  useEffect(() => {
    initLogging();
    return removeLogging;
  }, []);

  return (
    <ErrorBoundary>
      <IntlProvider locale="en">
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <Switch>
              <Route exact path="/operators/login" component={Login} />
              <Route exact path="/testoperators/login" component={Login} />
              <Route path="/loan-officer" component={LoanOfficerDashboard} />
              <Route path="/capital-markets" component={CapitalMarketsDashboard} />
              <Route path="/settlement-agent" component={SettlementAgentDashboard} />
              <Route path="/reporting" component={ReportingDashboard} />
              <Route
                exact
                path="/underwriter/app/:appId/documents/viewer/:docId"
                component={DocumentViewer}
              />
              <Route path="/underwriter" component={UnderwriterDashboard} />
              <Route path="/tools" component={ToolsDashboard} />
              <Route exact path="/404" render={() => <FourOhFour />} />
              <Route exact path="/" render={() => <Redirect to="/underwriter" />} />
              {/* Fallback to the /404 page if the route does not exist */}
              <Route path="*" component={() => <Redirect to="/underwriter" />} />
            </Switch>
          </ConnectedRouter>
        </Provider>
      </IntlProvider>
    </ErrorBoundary>
  );
};

export default App;
